import React, { useEffect, useState } from 'react'
import Summary from '../components/Summary/Summary'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { fetchLabels } from '../utils/Label'
import Transactions from "../components/Statement/Transactions"
import { fetchData, getAccountStatement } from '../utils/Utils'
import { useNavigate } from 'react-router-dom';
import { voiceStore } from '../stores/voiceStore'
import { observer } from 'mobx-react-lite'

const SoaPage = () => {
    const [customerInfo, setCustomerInfo] = useState(null);
    const [labels, setLabels] = useState('')
    const [accountData, setAccountData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [flag, setFlag] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLabelsData = async () => {
            const updatedLabels = await fetchLabels();
            setLabels(updatedLabels)
        };

        fetchLabelsData();
    }, [sessionStorage.getItem("CommunicationLanguage")], voiceStore.language);


    useEffect(() => {
        getAccountStatement()
            .then((data) => {
                if (!data.success) {
                    navigate('/');
                } else {
                    setFlag(data.success);
                    setAccountData(data.data);
                }
            })
            .catch((error) => {
                console.error('Failed to fetch account data:', error);
                navigate('/');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchData()
            .then(data => {
                // sessionStorage.setItem("CommunicationLanguage", JSON.stringify(data?.data?.CustomerDetails.CommunicationLanguage))
                setCustomerInfo(data.data);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        voiceStore.setVoiceCommand("You can view your detailed account statement here.")
    }, []);
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div>Loading...</div>
            </div>
        );
    }
    return (
        <>
            <div className="flex flex-col min-h-screen">
                <Header breadcrumbs="Customer App" labels={labels} customerInfo={customerInfo} accountData={accountData} flag={flag} />
                <div className=" mx-4 mb-16 font-gotham-rounded">
                    {accountData ? <Transactions data={accountData} labels={labels} /> : <Summary labels={labels} customerInfo={customerInfo} />}
                </div>
                <Footer className="fixed bottom-0 w-full bg-white" labels={labels} customerInfo={customerInfo} />
            </div>
        </>
    )
}

export default observer(SoaPage)
